import { LayoutDashboard, Package, Users, FileText, DollarSign, Receipt, Settings, UsersRound, ChevronDown, TrendingUp, BarChart3, Wallet, ArrowDownCircle, ArrowUpCircle, Activity, FileCode, Calculator, FileBarChart, PieChart, MapPin, Route, Tag, Globe, Map, Building, CreditCard, Landmark, Banknote, ListChecks, BookOpen, Layers, FolderTree, Warehouse, Shield, Truck, ArrowLeftRight, ShieldCheck, Percent, Fuel, Hash, ShoppingCart, ClipboardList, Wrench, MessageSquare, PackageCheck, Factory, ClipboardCheck, AlertTriangle, Sparkles, GitMerge, FileCheck, ArrowRightLeft, SlidersHorizontal, FileKey, History, Building2, ShoppingBag, TrendingDown, FileUp, Target, RotateCcw, Scale, Pill, FolderKanban, Clock, Radio, CalendarClock, Bot, Upload, ServerCog, KeyRound, UserCircle, Car, Briefcase } from "lucide-react";
import logo from "@/assets/logo.jpg";
import { NavLink } from "@/components/NavLink";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { isPontoStandalone, APP_NOME, APP_TAGLINE } from "@/lib/appMode";
import { menuVisivelParaTipo } from "@/lib/tipoEmpresa";
import { useTipoEmpresaAtual } from "@/features/empresa/hooks/useEmpresa";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubItem,
  SidebarMenuSubButton,
  useSidebar,
} from "@/components/ui/sidebar";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

const menuItems = [
  { title: "Dashboard",   url: "/",       icon: LayoutDashboard },
  { title: "Mentor IA",  url: "/mentor", icon: Sparkles },
  { title: "Agentes (Operacional)", url: "/mentor/operacional", icon: Bot },
  {
    title: "RH / Ponto",
    icon: CalendarClock,
    submenu: [
      { title: "Meu Ponto",          url: "/rh/ponto/meu",     icon: UserCircle },
      { title: "Painel",             url: "/rh/ponto/painel",  icon: Activity },
      { title: "Registrar Ponto",    url: "/rh/ponto/batida",  icon: Radio },
      { title: "Aprovação de Ajustes", url: "/rh/ponto/ajustes", icon: ClipboardCheck },
      { title: "Funcionários & Escala", url: "/rh/ponto/funcionarios", icon: UsersRound },
      { title: "Cargos",             url: "/rh/ponto/cargos", icon: Briefcase },
      { title: "Departamentos",      url: "/rh/ponto/departamentos", icon: Building2 },
      { title: "Configuração REP-P", url: "/rh/ponto/config",  icon: Settings },
      { title: "Dispositivos",       url: "/rh/ponto/dispositivos", icon: Radio },
      { title: "Consentimento LGPD", url: "/rh/ponto/consentimento", icon: ShieldCheck },
      { title: "Jornadas",           url: "/rh/ponto/jornadas", icon: CalendarClock },
      { title: "Feriados",           url: "/rh/ponto/feriados", icon: CalendarClock },
      { title: "Espelho de Ponto",   url: "/rh/ponto/espelho", icon: Clock },
      { title: "Comprovantes",       url: "/rh/ponto/comprovantes", icon: FileText },
      { title: "Exportações fiscais", url: "/rh/ponto/exportacoes", icon: FileCheck },
    ],
  },
  {
    title: "Cadastros Gerais",
    icon: Package,
    submenu: [
      {
        title: "Contábil",
        icon: BookOpen,
        submenu: [
          { title: "Centros de Custo",          url: "/cadastros/centros-custo",           icon: Layers },
          { title: "Contas Despesa/Receita",    url: "/cadastros/contas-despesa-receita",  icon: ListChecks },
          { title: "Grupos Despesa/Receita",    url: "/cadastros/grupos-despesa-receita",  icon: FolderTree },
          { title: "Plano Contas Gerencial",    url: "/cadastros/plano-contas-gerencial",  icon: BookOpen },
          { title: "Plano de Contas",           url: "/cadastros/plano-contas",            icon: BookOpen },
        ]
      },
      {
        title: "Estoque",
        icon: Warehouse,
        submenu: [
          { title: "Locais de Estoque",         url: "/cadastros/locais-estoque",          icon: Warehouse      },
        ]
      },
      {
        title: "Frotas",
        icon: Truck,
        submenu: [
          { title: "Veículos",                  url: "/cadastros/veiculos",                icon: Truck },
        ]
      },
      {
        title: "Transporte (CT-e/MDFe)",
        icon: Truck,
        submenu: [
          { title: "Veículos",                  url: "/cadastros/transporte/veiculos",     icon: Truck },
          { title: "Condutores",                url: "/cadastros/transporte/condutores",   icon: Users },
          { title: "Reboques",                  url: "/cadastros/transporte/reboques",     icon: Truck },
        ]
      },
      {
        title: "Fiscal",
        icon: Receipt,
        submenu: [
          { title: "ANP — Combustíveis",            url: "/cadastros/fiscal/anp",              icon: Fuel },
          { title: "Monofásicos da ANP",            url: "/cadastros/fiscal/monofasico-anp",   icon: Fuel },
          { title: "Benefício Fiscal (CBenef)",  url: "/cadastros/fiscal/cbenef",           icon: Receipt },
          { title: "CEST",                      url: "/cadastros/fiscal/cest",             icon: Tag },
          { title: "CFOP",                      url: "/cadastros/fiscal/cfop",             icon: FileCode },
          { title: "CST ICMS",                  url: "/cadastros/fiscal/cst-icms",         icon: FileCode },
          { title: "Class. Tributária (IBS/CBS)", url: "/cadastros/fiscal/cclass-trib",    icon: BookOpen },
          { title: "Correlação CFOP/CST",       url: "/cadastros/fiscal/correlacao-cfop-cst", icon: ArrowLeftRight },
          { title: "Regra Fiscal",              url: "/cadastros/fiscal/regra-fiscal",     icon: SlidersHorizontal },
          { title: "FCP por NCM",               url: "/cadastros/fiscal/fcp-partilha",     icon: DollarSign },
          { title: "Monofásicos PIS/COFINS",    url: "/cadastros/fiscal/monofasicos",        icon: Percent },
          { title: "NCM",                       url: "/cadastros/fiscal/ncm",              icon: Hash },
          { title: "Natureza de Operação",      url: "/cadastros/fiscal/natureza-operacao",icon: FileText },
          { title: "Classificação Fiscal",       url: "/cadastros/fiscal/classificacao-fiscal", icon: ShieldCheck },
          { title: "Tributos UF Destino",       url: "/cadastros/fiscal/tributos-uf-destino", icon: MapPin },
        ]
      },
      {
        title: "Financeiro",
        icon: Banknote,
        submenu: [
          { title: "Bancos",                    url: "/cadastros/bancos",                  icon: Landmark },
          { title: "Cartões",                   url: "/cadastros/cartoes",                 icon: CreditCard },
          { title: "Condições de Pagamento",    url: "/cadastros/condicoes-pagamento",     icon: ListChecks },
          { title: "Contas Correntes",          url: "/cadastros/contas-correntes",        icon: Wallet },
          { title: "Formas de Pagamento",       url: "/cadastros/formas-pagamento",        icon: DollarSign },
          { title: "Operações de Fluxo de Caixa", url: "/cadastros/operacoes-fluxo-caixa", icon: ArrowLeftRight },
        ]
      },
      {
        title: "Localidades",
        icon: MapPin,
        submenu: [
          { title: "Cidades",                   url: "/cidades",                           icon: Building },
          { title: "Estados",                   url: "/estados",                           icon: Map },
          { title: "Países",                    url: "/paises",                            icon: Globe },
        ]
      },
      {
        title: "Pessoas & Empresas",
        icon: Users,
        submenu: [
          { title: "Grupos de Clientes",        url: "/grupos-clientes",                   icon: UsersRound },
          { title: "Pessoas",                   url: "/pessoas",                           icon: Users },
        ]
      },
      {
        title: "Produtos",
        icon: Package,
        submenu: [
          { title: "Produtos",                  url: "/produtos",                          icon: Package },
          { title: "Grade X",                   url: "/produtos/grades-x",                 icon: Package },
          { title: "Grade Y",                   url: "/produtos/grades-y",                 icon: Package },
          { title: "Grupo",                     url: "/produtos/grupos",                   icon: Package },
          { title: "Marca",                     url: "/produtos/marcas",                   icon: Tag },
          { title: "Modelo",                    url: "/produtos/modelos",                  icon: Tag },
          { title: "Garantia",                  url: "/produtos/garantias",                icon: Tag },
          { title: "Opcionais",                 url: "/produtos/opcionais",                icon: Package },
          { title: "Seção",                     url: "/produtos/secoes",                   icon: Package },
          { title: "Subgrupo",                  url: "/produtos/subgrupos",                icon: Package },
          { title: "Subseção",                  url: "/produtos/subsecoes",                icon: Package },
          { title: "Tabelas de Preço",          url: "/tabelas-preco",                     icon: Tag },
          { title: "Unidade",                   url: "/produtos/unidades",                 icon: Tag },
        ]
      },
      {
        title: "Rotas",
        icon: Route,
        submenu: [
          { title: "Cadastro de Rotas",         url: "/rotas",                             icon: Route },
          { title: "Montagem de Rota",          url: "/rotas/montagem",                    icon: Map },
        ]
      },
    ]
  },
  {
    title: "PDV",
    icon: ShoppingBag,
    submenu: [
      { title: "Frente de Caixa",        url: "/pdv/frente-caixa",         icon: ShoppingBag },
      { title: "Histórico de Estornos",  url: "/pdv/historico-estornos",   icon: RotateCcw   },
      { title: "Conciliação de Caixa",   url: "/pdv/conciliacao-caixa",    icon: Scale       },
    ]
  },
  {
    title: "Operacional",
    icon: ShoppingCart,
    submenu: [
      { title: "Pedidos de Venda (DAV)", url: "/operacional/dav",          icon: ShoppingCart  },
      { title: "Orçamentos",             url: "/operacional/orcamentos",   icon: FileText      },
      { title: "Entregas",               url: "/operacional/entregas",     icon: Truck         },
      { title: "Separação (Wave)",       url: "/operacional/waves",        icon: Layers        },
      { title: "Ordens de Serviço",      url: "/operacional/os",           icon: Wrench        },
      { title: "Status de OS",           url: "/operacional/status-os",    icon: Tag           },
      { title: "Venda Condicional",      url: "/operacional/condicional",  icon: PackageCheck  },
      { title: "Cargas / Rota",          url: "/operacional/cargas",       icon: ClipboardList },
      { title: "Controle de Garantias",   url: "/operacional/garantias",   icon: ShieldCheck   },
      { title: "Receitas Médicas (SNGPC)", url: "/operacional/sngpc-receitas", icon: Pill        },
      { title: "Transmissões SNGPC",      url: "/operacional/sngpc-transmissoes", icon: Radio   },
      { title: "Projetos",                url: "/operacional/projetos",    icon: FolderKanban  },
      { title: "Apontamento de Horas",    url: "/operacional/apontamento-horas",  icon: Clock     },
      { title: "Aprovação de Timesheet",  url: "/operacional/aprovacao-timesheet", icon: ClipboardCheck },
    ]
  },
  {
    title: "CRM",
    icon: MessageSquare,
    submenu: [
      { title: "Atendimentos", url: "/operacional/crm",           icon: MessageSquare },
      { title: "Atividades",   url: "/operacional/crm-atividades",icon: CalendarClock },
      { title: "Campanhas",    url: "/operacional/crm-campanhas", icon: Radio         },
      { title: "Visão 360°",   url: "/operacional/crm-visao360",  icon: Target        },
      { title: "Pipeline",     url: "/operacional/crm-pipeline",  icon: TrendingUp    },
      { title: "Dashboard",    url: "/operacional/crm-dashboard", icon: BarChart3     },
      { title: "Relatórios",   url: "/operacional/crm-relatorios",icon: FileBarChart  },
    ]
  },
  {
    title: "Produção",
    icon: Factory,
    submenu: [
      { title: "PCP — Produção",            url: "/operacional/pcp",            icon: Factory       },
      { title: "Ficha Técnica / BOM",       url: "/operacional/fichas-tecnicas", icon: BookOpen     },
      { title: "Etapas de Produção",        url: "/operacional/etapas-producao", icon: GitMerge     },
      { title: "Planejamento (MRP)",        url: "/operacional/planejamento-mrp", icon: Calculator   },
      { title: "Requisições de Materiais",  url: "/operacional/requisicoes",    icon: ClipboardList },
      { title: "Liberação de Desconto",     url: "/operacional/liberacao-desconto", icon: Percent   },
    ]
  },
  {
    title: "Compras",
    icon: ShoppingBag,
    submenu: [
      { title: "Fornecedores",          url: "/compras/fornecedores",       icon: Building2       },
      { title: "Requisições de Compra", url: "/compras/requisicoes",        icon: ClipboardList   },
      { title: "Cotações (RFQ)",        url: "/compras/cotacoes",           icon: FileText        },
      { title: "Ordens de Compra (PO)", url: "/compras/ordens",             icon: ShoppingCart    },
      { title: "Recebimentos",          url: "/compras/recebimentos",       icon: PackageCheck    },
      { title: "Importar NF-e",         url: "/compras/recebimentos/importar", icon: FileUp       },
      { title: "Fluxo de Caixa",        url: "/compras/relatorios/fluxo-caixa", icon: Wallet      },
      { title: "Spend Analytics",       url: "/compras/relatorios/spend-analytics", icon: BarChart3 },
      { title: "Performance (OTIF)",    url: "/compras/relatorios/performance-fornecedores", icon: Target },
      { title: "Relatório de POs",      url: "/compras/relatorios/pedidos",     icon: ClipboardCheck  },
      { title: "Orçamento (Budget)",    url: "/compras/budget",                 icon: Target          },
      { title: "Budget × Realizado",    url: "/compras/relatorios/budget-vs-realizado", icon: PieChart },
      { title: "Histórico de Preços",   url: "/compras/historico-precos",   icon: TrendingDown    },
      { title: "Alçadas de Aprovação",  url: "/compras/alcadas",            icon: Shield          },
    ]
  },
  {
    title: "Gestão de Estoque",
    icon: Warehouse,
    submenu: [
      { title: "Posição de Estoque",        url: "/estoque/posicao",        icon: Package        },
      { title: "Movimentações",             url: "/estoque/movimentacoes",  icon: ArrowLeftRight },
      { title: "Histórico por Produto",     url: "/estoque/historico",      icon: History        },
      { title: "Inventário",                url: "/estoque/inventario",     icon: ClipboardCheck },
      { title: "Necessidade de Reposição",  url: "/estoque/reposicao",      icon: AlertTriangle  },
      { title: "Gestão de Lotes",           url: "/estoque/lotes",          icon: Layers         },
      { title: "Etiquetas",                url: "/estoque/etiquetas",      icon: Tag            },
      { title: "Transferências",            url: "/estoque/transferencias", icon: ArrowRightLeft },
      { title: "Veículos (RENAVE)",         url: "/estoque/veiculos",       icon: Car },
      { title: "Regras de Aprovação",       url: "/estoque/transferencias/regras", icon: ShieldCheck },
      { title: "Ciclos de Contagem",        url: "/estoque/ciclos-contagem", icon: CalendarClock },
      { title: "Contagem Cíclica",          url: "/estoque/contagens-ciclo", icon: ClipboardList },
      { title: "Ajustes de Estoque",        url: "/estoque/ajustes",        icon: History        },
      { title: "Relatórios de Estoque",     url: "/estoque/relatorios",     icon: BarChart3      },
    ]
  },
  {
    title: "Financeiro",
    icon: DollarSign,
    submenu: [
      { title: "Caixa",                        url: "/financeiro/caixa",                  icon: Wallet },
      { title: "Controle de Caixas",          url: "/financeiro/controle-caixas",        icon: Layers },
      { title: "Conciliação Bancária",        url: "/financeiro/conciliacao",            icon: GitMerge },
      { title: "Conciliação OFX (Banco)",     url: "/financeiro/conciliacao-ofx",        icon: FileUp },
      { title: "Integração Bancária (API)",   url: "/financeiro/integracao-bancaria",    icon: Landmark },
      { title: "Gerenciamento de Cartões",    url: "/financeiro/gerenciamento-cartao",   icon: CreditCard },
      { title: "Pagamento em Lote",           url: "/financeiro/pagamento-lote",         icon: Sparkles },
      { title: "Ativo Fixo (Imobilizado)",    url: "/financeiro/ativos-fixos",           icon: Building2 },
      { title: "Contas a Pagar",               url: "/financeiro/contas-pagar",           icon: ArrowDownCircle },
      { title: "Contas a Pagar — Gerencial",   url: "/financeiro/contas-pagar/gerencial", icon: Building2 },
      { title: "Contas a Receber",             url: "/financeiro/contas-receber",         icon: ArrowUpCircle },
      { title: "Contas a Receber — Gerencial", url: "/financeiro/contas-receber/gerencial", icon: Users },
      { title: "Faturas",                      url: "/financeiro/faturas",                icon: Layers },
      { title: "Renegociação",                 url: "/financeiro/renegociacoes",          icon: GitMerge },
      { title: "Gestão de Boletos",            url: "/financeiro/boletos",                icon: FileCheck },
      { title: "Transferências entre Caixas", url: "/financeiro/transferencias",         icon: ArrowRightLeft },
      { title: "Relatórios Financeiros",       url: "/financeiro/relatorios",             icon: BarChart3 },
      { title: "Dashboard Executivo",          url: "/financeiro/dashboard-executivo",    icon: PieChart },
      { title: "Fluxo de Caixa",              url: "/financeiro/fluxo-caixa",            icon: Activity },
      { title: "Fluxo de Caixa Gerencial",    url: "/financeiro/fluxo-caixa-gerencial",  icon: TrendingUp },
    ]
  },
  {
    title: "Fiscal",
    icon: Receipt,
    submenu: [
      { title: "Impostos",      url: "/fiscal/impostos",      icon: Calculator },
      { title: "NF-e",          url: "/fiscal/notas-fiscais", icon: FileBarChart },
      { title: "NFS-e",         url: "/fiscal/nfse",          icon: FileBarChart },
      { title: "NFC-e",         url: "/fiscal/nfce/emitir",   icon: FileBarChart },
      { title: "SPED",          url: "/fiscal/sped",          icon: FileCode },
      {
        title: "Transporte CT-e/MDFe",
        icon: Truck,
        submenu: [
          { title: "CT-e (mod 57)",    url: "/fiscal/cte",       icon: FileText },
          { title: "CT-e OS (mod 67)", url: "/fiscal/cte-os",    icon: FileText },
          { title: "MDF-e",            url: "/fiscal/mdfe",      icon: FileText },
          { title: "Averbação",        url: "/fiscal/averbacao", icon: FileCheck },
        ]
      },
    ]
  },
  {
    title: "Contábil",
    icon: BookOpen,
    submenu: [
      { title: "Apurações",        url: "/contabil/apuracoes",         icon: Calculator },
      { title: "Lançamentos",       url: "/contabil/lancamentos",      icon: BookOpen },
      { title: "Livro Razão",       url: "/contabil/razao",            icon: BookOpen },
      { title: "Parametrização",    url: "/contabil/parametrizacao",   icon: BookOpen },
      { title: "Relatórios",        url: "/contabil/relatorios",       icon: BookOpen },
      { title: "Central Fiscal",    url: "/contabil/central-fiscal",   icon: BarChart3 },
      { title: "Plataforma Contador", url: "/contabil/plataforma-contador", icon: Users },
    ]
  },
  {
    title: "Relatórios",
    icon: FileText,
    submenu: [
      { title: "Estoque",     url: "/estoque/relatorios",     icon: BarChart3  },
      { title: "Financeiro",  url: "/relatorios/financeiro",  icon: Wallet     },
      { title: "Fiscais",     url: "/relatorios/fiscais",     icon: Receipt    },
      { title: "Gerencial",   url: "/relatorios/gerencial",   icon: PieChart   },
      { title: "Vendas",      url: "/relatorios/vendas",      icon: TrendingUp },
    ]
  },
  {
    title: "Integrações",
    icon: GitMerge,
    submenu: [
      { title: "Mercado Livre",        url: "/integracao/mercadolivre", icon: ShoppingCart },
      { title: "Open Finance (Pluggy)", url: "/integracao/open-finance", icon: Landmark      },
      { title: "Smart TEF",             url: "/integracao/smart-tef",    icon: CreditCard    },
      {
        title: "WhatsApp",
        icon: MessageSquare,
        submenu: [
          { title: "Oficial (Cloud)", url: "/configuracoes/whatsapp-cloud",      icon: ShieldCheck   },
          { title: "Z-API",           url: "/configuracoes/whatsapp",            icon: MessageSquare },
          { title: "Templates",       url: "/configuracoes/whatsapp-templates",  icon: FileText      },
        ]
      },
    ]
  },
  {
    title: "Configurações",
    icon: Settings,
    submenu: [
      { title: "Empresa",               url: "/configuracoes/empresa", icon: Building },
      { title: "Chaves de API",         url: "/configuracoes/api-keys", icon: KeyRound },
      { title: "Documentos Fiscais",    url: "/configuracoes/fiscal",  icon: FileKey },
      { title: "Importação de Dados",   url: "/configuracoes/importacao", icon: Upload },
      { title: "Parâmetros do Sistema", url: "/configuracoes/sistema", icon: SlidersHorizontal },
      { title: "RENAVE",                url: "/configuracoes/renave",  icon: Car },
      { title: "Dashboards Padrão",     url: "/configuracoes/dashboard-perfis", icon: LayoutDashboard },
      { title: "Perfis",                url: "/cadastros/perfis",      icon: UsersRound },
      { title: "Permissões",            url: "/config/perfis",         icon: Shield },
      { title: "Usuários",              url: "/cadastros/usuarios",    icon: Users },
    ]
  },
];

/** Tira os itens que o ramo da empresa não vê e os submenus que ficaram vazios. */
const filtrarPorTipo = (itens: any[], tipo: number | null | undefined): any[] =>
  itens
    .map((item) => (item.submenu ? { ...item, submenu: filtrarPorTipo(item.submenu, tipo) } : item))
    .filter((item) => (item.submenu ? item.submenu.length > 0 : menuVisivelParaTipo(item.url, tipo)));

export function AppSidebar() {
  const { open } = useSidebar();
  const location = useLocation();
  const currentPath = location.pathname;
  const [openSubmenus, setOpenSubmenus] = useState<string[]>(["Cadastros Gerais"]);
  const { user } = useAuth();
  const tipoEmpresa = useTipoEmpresaAtual(user?.empresa?.id);
  const itensVisiveis = isPontoStandalone
    ? menuItems.filter((i) => i.title === "RH / Ponto")
    : filtrarPorTipo(menuItems, tipoEmpresa);

  const isActive = (path: string) => currentPath === path;
  
  const isSubmenuActive = (submenu: any[]): boolean => {
    return submenu.some(item => {
      if (item.submenu) {
        return isSubmenuActive(item.submenu);
      }
      return isActive(item.url);
    });
  };

  const toggleSubmenu = (title: string) => {
    setOpenSubmenus(prev => 
      prev.includes(title) 
        ? prev.filter(t => t !== title) 
        : [...prev, title]
    );
  };

  const renderSubItem = (subItem: any, level: number = 0) => {
    if (subItem.submenu) {
      return (
        <Collapsible
          key={subItem.title}
          open={openSubmenus.includes(subItem.title)}
          onOpenChange={() => toggleSubmenu(subItem.title)}
          className="group/nested"
        >
          <SidebarMenuSubItem>
            <CollapsibleTrigger asChild>
              <SidebarMenuSubButton 
                className={`hover:bg-sidebar-accent/80 transition-all duration-150 cursor-pointer ${isSubmenuActive(subItem.submenu) ? 'bg-sidebar-accent text-sidebar-accent-foreground font-medium' : ''}`}
              >
                <subItem.icon className="h-4 w-4 shrink-0 opacity-70" />
                {open && <span className="text-[13px]">{subItem.title}</span>}
                {open && (
                  <ChevronDown className="ml-auto h-3 w-3 transition-transform duration-200 group-data-[state=open]/nested:rotate-180 opacity-50" />
                )}
              </SidebarMenuSubButton>
            </CollapsibleTrigger>
          </SidebarMenuSubItem>
          <CollapsibleContent>
            <SidebarMenuSub className="ml-2 border-l border-sidebar-border/50">
              {subItem.submenu.map((nestedItem: any) => renderSubItem(nestedItem, level + 1))}
            </SidebarMenuSub>
          </CollapsibleContent>
        </Collapsible>
      );
    }

    return (
      <SidebarMenuSubItem key={subItem.title}>
        <SidebarMenuSubButton asChild>
          <NavLink 
            to={subItem.url} 
            end 
            className="hover:bg-sidebar-accent/80 transition-all duration-150"
            activeClassName="bg-sidebar-primary/15 text-sidebar-primary font-medium"
          >
            <subItem.icon className="h-4 w-4 shrink-0 opacity-70" />
            {open && <span className="text-[13px]">{subItem.title}</span>}
          </NavLink>
        </SidebarMenuSubButton>
      </SidebarMenuSubItem>
    );
  };

  return (
    <Sidebar className="border-r border-sidebar-border bg-gradient-sidebar">
      <SidebarContent>
        {/* Brand */}
        <div className="px-5 py-5 border-b border-sidebar-border/60">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg overflow-hidden shadow-md shrink-0">
              <img src={logo} alt={APP_NOME} className="h-9 w-9 object-cover" />
            </div>
            {open && (
              <div className="animate-fade-in">
                <h1 className="font-bold text-sidebar-primary-foreground text-base font-heading tracking-tight leading-none">
                  {APP_NOME}
                </h1>
                <p className="text-[11px] text-sidebar-muted mt-0.5">{APP_TAGLINE}</p>
              </div>
            )}
          </div>
        </div>
        
        {/* Gestor Hub — visível só para admin global (suporte Udisys); oculto no standalone */}
        {!isPontoStandalone && user?.isAdminGlobal && (
          <SidebarGroup className="mt-2">
            <SidebarGroupLabel className={`${open ? "px-5" : "px-3"} text-[11px] uppercase tracking-wider font-medium text-amber-600`}>
              Suporte Udisys
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to="/admin/hub"
                      end
                      className="hover:bg-sidebar-accent/80 transition-all duration-150"
                      activeClassName="bg-amber-500/15 text-amber-700 font-medium"
                    >
                      <ServerCog className="h-[18px] w-[18px] shrink-0 text-amber-600" />
                      {open && <span className="text-[13.5px] text-amber-700 font-medium">Gestor Hub</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        <SidebarGroup className="mt-3">
          <SidebarGroupLabel className={`${open ? "px-5" : "px-3"} text-[11px] uppercase tracking-wider text-sidebar-muted font-medium`}>
            Menu Principal
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {itensVisiveis.map((item) => (
                <SidebarMenuItem key={item.title}>
                  {item.submenu ? (
                    <Collapsible
                      open={openSubmenus.includes(item.title)}
                      onOpenChange={() => toggleSubmenu(item.title)}
                      className="group/collapsible"
                    >
                      <CollapsibleTrigger asChild>
                        <SidebarMenuButton 
                          className={`hover:bg-sidebar-accent/80 transition-all duration-150 ${isSubmenuActive(item.submenu) ? 'bg-sidebar-accent text-sidebar-accent-foreground font-medium' : ''}`}
                        >
                          <item.icon className="h-[18px] w-[18px] shrink-0 opacity-75" />
                          {open && <span className="text-[13.5px]">{item.title}</span>}
                          {open && (
                            <ChevronDown className="ml-auto h-4 w-4 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-180 opacity-50" />
                          )}
                        </SidebarMenuButton>
                      </CollapsibleTrigger>
                      <CollapsibleContent>
                        <SidebarMenuSub>
                          {item.submenu.map((subItem) => renderSubItem(subItem))}
                        </SidebarMenuSub>
                      </CollapsibleContent>
                    </Collapsible>
                  ) : (
                    <SidebarMenuButton asChild>
                      <NavLink 
                        to={item.url} 
                        end 
                        className="hover:bg-sidebar-accent/80 transition-all duration-150"
                        activeClassName="bg-sidebar-primary/15 text-sidebar-primary font-medium"
                      >
                        <item.icon className="h-[18px] w-[18px] shrink-0 opacity-75" />
                        {open && <span className="text-[13.5px]">{item.title}</span>}
                      </NavLink>
                    </SidebarMenuButton>
                  )}
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
